const TOKEN_KEY = "@mychapperoneAdminDashboardtoken:key";
const CONTRACT_KEY = "@contractChapperoneAdmintoken:key";
const ORG_KEY = "@organisationAdmin:key";

export { TOKEN_KEY, CONTRACT_KEY, ORG_KEY };
